import { colors } from '@mui/material';
import { IPalette } from './types';
import styles from '../assets/scss/_variables.scss';

const white = '#FFFFFF';
const black = '#000000';
const pink = '#FF4070';
const cyan = '#D0FDF9';

const palette: IPalette = {
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  black,
  cellHeight: styles.cellHeight,
  cellIconColor: styles.cellIconColor,
  chartColors: {
    black: '#082444',
    blue: '#B2DCFF',
    cyan: '#C6FFF2',
    dark: '#171717',
    darkBlue: '#1A64B1',
    darkGreen: '#106A5B',
    darkGreen2: '#00A58C',
    darkOrange: '#B25E00',
    green: '#B6F5EA',
    grey: '#B4B4B4',
    lightBlue: '#52A3FF',
    lightGreen: '#66D3BD',
    lightOrange: '#FFAE57',
    red: '#F77C7C',
    yellow: '#FFC657',
  },
  cyan,
  disabled: styles.disabled,
  divider: colors.grey[200],
  error: {
    contrastText: white,
    dark: colors.red[900],
    light: colors.red[400],
    main: colors.red[600],
    pink: '#FF4070',
    veryLight: colors.red[50],
  },
  green: {
    500: styles.green500,
    primary: styles.green,
  },
  grey: {
    100: styles.grey100,
    200: styles.grey200,
    300: styles.grey300,
    400: styles.grey400,
    500: styles.grey500,
    600: styles.grey600,
    700: styles.grey700,
    800: styles.grey800,
    900: styles.grey900,
  },
  headerCellHeight: styles.headerCellHeight,
  icon: colors.blueGrey[600],
  info: {
    contrastText: white,
    dark: colors.blue[900],
    light: colors.blue[400],
    main: colors.blue[600],
  },
  pink,
  primary: {
    100: styles.primary100,
    200: styles.primary200,
    300: styles.primary300,
    400: styles.primary400,
    500: styles.primary500,
    600: styles.primary600,
    700: styles.primary700,
    800: styles.primary800,
    900: styles.primary900,
    contrastText: white,
    dark: styles.primary900,
    extraLight: styles.primary50,
    light: styles.primary200,
    main: styles.primaryColor,
  },
  scrollbarThumb: styles.scrollbarThumb,
  scrollbarTrack: styles.scrollbarTrack,
  secondary: {
    100: styles.secondary100,
    200: styles.secondary200,
    300: styles.secondary300,
    400: styles.secondary400,
    500: styles.secondary500,
    600: styles.secondary600,
    700: styles.secondary700,
    800: styles.secondary800,
    900: styles.secondary900,
    contrastText: white,
    dark: styles.secondary800,
    light: styles.secondary200,
    main: styles.secondary500,
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    light: colors.green[400],
    main: colors.green[600],
  },
  text: {
    link: colors.blue[600],
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    light: colors.orange[400],
    main: colors.orange[600],
    veryLight: colors.orange[200],
  },
  white,
};

export default palette;
